var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342.293,
    height: 296.709,
    viewBox: "0 0 342.293 296.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}.b{clip-path:url(#b);}.c{fill:url(#c);}.d{fill:#fabaac;}.e{fill:#f8a092;}.f{fill:#2d5eaa;}.g{fill:#3a7ab5;}.h{fill:#4e91d2;}.i{fill:#7ac2ed;}.j{fill:#9894d2;}.k{fill:#fff;}.l{fill:#93daf7;}.m{fill:#abaaa9;}.n{fill:#f14554;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.779-415.976c-16.422,0-30.568-5.184-36.964-12.644L313.4-447.474l38.039,21.987c-7.3,5.741-19.65,9.511-33.658,9.511M354.69-428.56l-37.01-21.391,13.772-7.968c15.7,2.985,26.934,10.967,26.934,20.344a13.755,13.755,0,0,1-3.7,9.015M278.436-432.2a12.335,12.335,0,0,1-1.265-5.374c0-8.091,8.366-15.146,20.75-18.847l11.189,6.47L278.436-432.2m34.955-20.228h0l-9.448-5.459a73.09,73.09,0,0,1,13.836-1.286c2.3,0,4.56.1,6.756.3l-11.143,6.449",
    transform: "translate(-277.171 459.173)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.556-432.941h-.412l40.844-23.64a11.605,11.605,0,0,1,.18,2.037c0,11.932-18.181,21.6-40.611,21.6m-8.218-.444c-18.487-2.019-32.39-10.724-32.39-21.158,0-11.929,18.181-21.6,40.608-21.6a74.62,74.62,0,0,1,10.8.772l26.769,15.488-45.788,26.5",
    transform: "translate(-375.948 476.143)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 29"
  }, /*#__PURE__*/React.createElement("image", {
    width: 51,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAdCAYAAAAHB1RsAAAABHNCSVQICAgIfAhkiAAAAJFJREFUWIXtlsENgDAMA52IAZmQyZiF8kK8oU5iVfG/ak7XurX9OAdWiAFePQMtYyUYNIxuGkY1DaOahlFNw7yrjTQGJ9v0QG7ApfFX5RwzNwlL3DtTDMQvgEJLcW1WABRbzcmW+p35vkuOoVwzwUD5xyzQUt2dCQCqLQCyJY02IwFpwAAUSzowTyaA9GCA30A3B5EGSo/iFFUAAAAASUVORK5CYII="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-277.171 555.089)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.171 -301.578)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.076 -1.864)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 86.763,
    height: 47.645,
    transform: "translate(0 0)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAcCAYAAADMW4fJAAAABHNCSVQICAgIfAhkiAAAAENJREFUWIXtzwENgDAAwLBzhdeIMKxwE09oyKpgu9b9vOMn5tcBJzWjakbVjKoZVTOqZlTNqJpRNaNqRtWMqhlVM6oNfzUDB9vashcAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(538.245 -346.429)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.721 -2.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 86.763,
    height: 49.407,
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M379.608-523.355c-7.51-2.562-24.75,6.375-31.368,9.515s-38.613,16.44-38.613,16.44l14.893,16.954s16.672-13.518,27.706-18.871,18.441-9.406,26.364-15.072c4.37-3.13,5.642-7.39,1.018-8.965",
    transform: "translate(53.327 51.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M351.311-513.984s-16.281,5.23-21.275,8.666S296-482.845,290.006-474.93s-6.935,20.961,1.565,27.47,15.83,20.778,23.4,24.686,24.926-10.188,43.522-17.864,22.857-7.943,30.526-12.905c8.895-5.751-5.751-37.429-12.031-40.241s-16.574-22.924-25.673-20.2",
    transform: "translate(13.441 67.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M381.223-513.819c-3.119-.032-5.688,4.7-9.882,9.4a33.945,33.945,0,0,1-14.53,9.12c-9.215,2.622-38.419,11.369-38.419,11.369l14.329,13.046a217.838,217.838,0,0,0,25.338-8.986,67.223,67.223,0,0,0,14.2-8.239c4.687-3.6,7.767-7.164,8.965-9.793,2.153-4.733,11.228-15.809,0-15.918",
    transform: "translate(67.729 67.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M344.71-515.183c-.666.331-8.532,1.382-12.669,3.605s-14.065,7.323-15.746,9.4c.374.437,2.647,3.573,2.647,3.573s8.084-6.53,11.555-8.5,14.213-8.077,14.213-8.077",
    transform: "translate(64.283 65.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M315.743-470.611s16.866-6.777,28.214-11.2c9.191-3.581,19.308-9.208,21.011-16.253,1.008-4.159,2.756-11.739,3.446-16.281.518-3.432-2.132-5.4-7.577-2.879-5.913,2.728-7.267,13.976-7.267,13.976s-11.46,4.222-16.556,7.841c-6.794-.37-21.271,1.79-21.271,1.79v23",
    transform: "translate(63.376 60.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M329.8-469.922s21.518-13.762,31.4-16.968c4.944-1.6,10.266-4.416,16.253-6.083s11.77-3.291,9.758-6.8c-4.313-7.541-22.025-1.667-28.9.55-9.518,3.066-38.145,12.028-38.145,12.028l9.635,17.275",
    transform: "translate(70.647 84.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M323.565-525.928c-2.164,3.239-2.706,5.332-5.994,12.75-6.04,13.638-16.44,27.442-19.749,34.755-2.3,5.082-9.529,18.833-12.412,28.517a14.68,14.68,0,0,0-.226,9.029c2.069,7.492,34.557-5.332,42.627-15.154s-2.59-19.964-2.689-21.285A62.761,62.761,0,0,1,325.4-495.4c3.676-7.936,5.378-14.783,5.209-21.32-.183-7.136-4.758-12.634-7.045-9.205",
    transform: "translate(12.18 46.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M291.259-497.816s-7.443,37.249-9.649,62.852c-.9,10.445-.493,55.377-.493,55.377h60.66s-1.332-76.155,3.08-85.36c4.024-8.394-43.931-28.841-52.347-32.351-.807-.338-1.251-.518-1.251-.518",
    transform: "translate(6.331 94.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M341.719-443.055c0,8.909-13.578,16.13-30.332,16.13s-30.328-7.221-30.328-16.13,13.578-16.133,30.328-16.133,30.332,7.221,30.332,16.133",
    transform: "translate(6.388 157.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M343.449-505.659s-10.787,1.339-14.7,1.889a72.508,72.508,0,0,0-8.585,1.931l2.5,2.354s15.432-4.6,20.781-6.174",
    transform: "translate(70.647 81.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M352.181-501.883s-10.022,1.011-13.328,2.115-7.88,3.309-10.146,3.584a24.28,24.28,0,0,1-4.807,0l1.776,3.862s8.246-3.528,12.362-5.071,14.142-4.49,14.142-4.49",
    transform: "translate(76.779 87.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M321.1-484.427s-8.969.5-13.744,3c-4.225,2.206-5.519,13.183-5.794,20.725s0,69.192,0,69.192,6.763-2.636,6.664-10.075c-.067-5.064-.183-39.378.356-60.131.257-9.748,1.339-15.185,4.423-17.642,3.44-2.735,3.7-2.847,8.095-5.068",
    transform: "translate(39.879 116.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M287.281-496.807s-.141,8.993,4.641,14.889a35.772,35.772,0,0,0,10.858,8.835s-3.168-5.029-7.746-11.341a111.531,111.531,0,0,1-7.753-12.384",
    transform: "translate(16.61 95.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M324.113-504.491s-9.931,10.833-14.206,14.614-10.3,11.661-10.3,11.661,13.709-5.057,24.5-7.993a86.765,86.765,0,0,1,21.828-2.668s-9.374-2.477-17.1-1.367c-10.555,1.515-17.835,3.394-17.835,3.394s11.767-8.542,13.1-17.641",
    transform: "translate(36.868 83.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M488.491-445.974c-9-17.635-6.273-13.62-22.744-34.127s-19.492-36.728-28.524-42.377-13.571-24.595-20.4-29.786c-3.464-2.625-12.073-6.66-8.768,5.343,2.64,9.564,14.967,31.3,14.967,31.3s-28.193,2.46-26.871-2.735-2.361-16.094-5.039-26.335c-2.615-10.012-14.209-13.754-14.209-4.049,0,6.84,1.47,14.8,1.3,16.468-2.224-4.662-6-10.576-10.858-8.958-7.633,2.541-2.985,13.173-.352,27.618s14.649,37.856,14.649,37.856S363.8-485.3,358.016-503.67c-1.04-12.422-6.453-21.483-13.222-18.808-4.031,1.593-3.344,7.313-1.73,17.93.867,5.684.592,14.512,3.147,20.979,5.462,13.832,17.811,18.526,29.993,30.194,3.189,3.052,12.609,11.439,20.817,20.2,4.557.828,11.686,2.875,16.87,7.908,5.6,5.441,22.11,14,28.524,19.136s11.932,8.095,12.482,35.48c.342,17.011-1.085,39.61-2.22,54.309a47.969,47.969,0,0,0,20.066,4.056c16.754,0,30.332-7.221,30.332-16.13v-46.613c0-24.235-8.1-58.228-14.583-70.947",
    transform: "translate(106.178 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M420.564-446.439c-.55-27.385-6.065-30.346-12.482-35.48s-22.924-13.695-28.524-19.136c-5.184-5.032-12.313-7.08-16.87-7.908,2.5,2.661,4.888,5.356,6.946,7.95,11.316,14.255,36.1,25.62,37.309,30.508,2.442,9.917,1.138,66.3,1.138,66.3,0,4.81,3.982,9.117,10.262,12.073,1.135-14.7,2.562-37.3,2.22-54.31",
    transform: "translate(140.51 75.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M382.463-516.364l-23.2,10.939S377.6-491.146,392.133-485.3c12.14,4.877,33.616,23.372,42.017,19.647,9.388-4.169,4.853-31.2,1.508-37.19-6.336-11.344-18.131-32.816-18.131-32.816l-35.065,19.294",
    transform: "translate(134.877 31.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M393.7-541.839l.032,14.153-7.365,3.672-.2-9.363,7.535-8.461",
    transform: "translate(179.082 21.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M462.932-523.254c-2.625-4.719-10.273-9.332-15.724-12.479s-17.042-8.853-25.222-10.368a11.255,11.255,0,0,0-7.235,1.357c-10.9,6.354-48.921,28.756-63.743,40.5-8.849,7.006-8.053,14.586-5.913,19.618,1.681,3.95,6.756,6.882,13.6,7.852,8.719,1.233,21.846,1.7,33.983-3.415,20.33-8.556,56.734-28.527,67.454-35.29,4.285-2.706,3.57-6.389,2.8-7.771",
    transform: "translate(109.296 14.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M462.932-528.245c-2.625-4.722-10.273-9.332-15.724-12.482s-17.042-8.849-25.222-10.364a11.255,11.255,0,0,0-7.235,1.357c-10.9,6.35-48.921,28.753-63.743,40.492-8.849,7.006-8.053,14.586-5.913,19.622,1.681,3.951,6.756,6.879,13.6,7.852,8.719,1.234,21.846,1.7,33.983-3.415,20.33-8.56,56.734-28.531,67.454-35.293,4.285-2.7,3.57-6.386,2.8-7.767",
    transform: "translate(109.296 6.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M458.228-528.531c-2.432-4.366-11.052-9.737-16.1-12.651s-15.777-8.2-23.347-9.6a10.433,10.433,0,0,0-6.7,1.258c-10.086,5.882-46.919,27.512-60.639,38.38-5.409,4.282-6.914,8.793-6.752,12.7A18.773,18.773,0,0,1,353.6-496.3c3.521,2.033,4.5,5.039,3.084,7.9v2.336c.606.134,1.226.257,1.871.345,8.074,1.145,20.228,1.572,31.463-3.158,18.822-7.926,55.321-28.7,65.576-34.4,2.819-1.568,3.351-3.975,2.639-5.258",
    transform: "translate(110.912 6.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M454.251-541.668a10.4,10.4,0,0,0-.747-1.11c-8.934,4.969-40.552,22.966-56.865,29.831-9.751,4.105-20.292,3.735-27.294,2.745-5.5-.779-9.575-3.136-10.925-6.308-1.716-4.042-2.358-10.128,4.75-15.76,3.771-2.985,9.564-6.914,15.985-11.044-10.706,6.646-21.352,13.564-27.364,18.325-6.132,4.86-7.041,10.019-6.245,14.177a17.439,17.439,0,0,1,7.016,2.03c3.408,1.966,4.437,4.842,3.224,7.619a26.816,26.816,0,0,0,2.833.578c7.742,1.1,19.4,1.5,30.18-3.034,18.057-7.6,53.08-27.537,62.919-33.006,2.7-1.5,3.21-3.813,2.53-5.043",
    transform: "translate(111.944 19.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M351.766-529.262a11.39,11.39,0,0,0-4.881-1.054,10.513,10.513,0,0,0-2.1.187,16.345,16.345,0,0,0,1,3.309c1.223,2.872,4.4,5.145,8.775,6.432l2.065.518v-2.65l.081-.18.243-.733.014-.042a9.1,9.1,0,0,0-5.2-5.786",
    transform: "translate(111.088 40.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M357.228-524.342l-.046-.208-.211-.723-.074-.2-.433-.821-.13-.187-.567-.715-.1-.113-.825-.744-.219-.166a10.2,10.2,0,0,0-1.04-.694,13.269,13.269,0,0,0-1.762-.828l-.7-.243c-.4-.137-.807-.264-1.226-.374l-.93-.215c-.377-.078-.758-.141-1.145-.2-.345-.053-.691-.106-1.047-.141l-.2-.014c-.627-.06-1.255-.116-1.9-.127a14.573,14.573,0,0,0,.271,2.15,10.5,10.5,0,0,1,2.1-.187,11.39,11.39,0,0,1,4.881,1.054,9.1,9.1,0,0,1,5.2,5.786l.053-.261.092-.694.014-.289-.063-.842",
    transform: "translate(110.919 39.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M338.627-524.193l-1.085,2.633,3.774,2.178,4.768-.5,2.869-1.656-7.457-4.307-2.869,1.656",
    transform: "translate(99.192 48.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M346.495-519.5l5.691-3.285-7.457-4.306-5.691,3.284,7.457,4.307",
    transform: "translate(101.65 46.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M357.726-529.815a10.5,10.5,0,0,0-1.491-.564l-15.044,8.687,7.457,4.307,13.719-7.922a8.692,8.692,0,0,0-4.641-4.507",
    transform: "translate(105.189 40.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M430.671-542.178c-4.782-2.759-14.935-7.753-22.1-9.082a9.85,9.85,0,0,0-6.34,1.188c-5.187,3.024-17.846,10.445-30.406,18.248-6.34,4.077-12.052,7.95-15.774,10.9-7.013,5.554-6.382,11.555-4.687,15.545,1.332,3.133,5.353,5.455,10.78,6.223,6.9.98,17.31,1.343,26.924-2.707,16.1-6.773,47.293-24.531,56.107-29.429-2.964-3.908-10.139-8.363-14.5-10.886",
    transform: "translate(120.074 6.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M392.453-547.5l26.082,13.74c.719-.423,1.381-.814,1.949-1.145l-28.031-14.766c-5.385,3.143-17.747,10.4-30.036,18.033-1.833,1.177-3.605,2.337-5.3,3.461l1.755,1.015c1.152-.761,2.329-1.526,3.542-2.308,12.289-7.63,24.651-14.886,30.036-18.029",
    transform: "translate(131.361 8.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M388.518-517.615c10.844-6.731,22.624-13.783,28.926-17.49l-26.082-13.74c-5.385,3.143-17.747,10.4-30.036,18.029-1.212.782-2.389,1.547-3.542,2.308l25.169,14.533c1.773-1.184,3.633-2.4,5.565-3.641",
    transform: "translate(132.452 10.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M356.646-539.875c-5.878,5.3-6.333,10.245-4.729,14.019a8.047,8.047,0,0,0,1.191,1.892l15.545-8.976-12.007-6.935",
    transform: "translate(121.5 24.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M368.761-536.684l-16.13,9.314a14.341,14.341,0,0,0,7.577,2.5c7.475.388,14.488.31,23.661-3.084l-15.108-8.726",
    transform: "translate(123.985 30.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M367.416-537.919v1.766l-15.545,8.976v-1.769l15.545-8.972",
    transform: "translate(122.736 28.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M356.646-540.543c-5.878,5.293-6.333,10.241-4.729,14.015a8.041,8.041,0,0,0,1.191,1.892l15.545-8.972-12.007-6.935",
    transform: "translate(121.5 23.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M368.761-537.353l-16.13,9.314a14.342,14.342,0,0,0,7.577,2.495c7.475.388,14.488.31,23.661-3.08l-15.108-8.729",
    transform: "translate(123.985 29.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M363.043-537.55l-10.6-.4.687,6.118Z",
    transform: "translate(123.681 28.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M365.161-536.328l.687,6.118-10.6-.395Z",
    transform: "translate(128.29 30.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M380.913-540c-6.269,6.245-2.308,17.716,4.268,24.774,2.654,2.847,4.028,12.147,8.067,21.853-5.036,5.579-9.187,40.15-5.832,46.32s47.578-.049,45.876-11.464c-3.852-25.846-14.276-40.4-24.771-59.9-4.275-7.94-8.655-10.964-12.726-15.15-9.008-9.275-12.176-9.134-14.882-6.435",
    transform: "translate(165.279 22.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M383.826-541.383s-6.156,3.591-3.894,8.613a30.3,30.3,0,0,0,4.451,6.516l8.669-7.661s-5.1-5.779-9.226-7.467",
    transform: "translate(168.022 22.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M410.324-507.22s-10.153,5.878-14.2,9.924-8.38,8.722-8.38,8.722,9.483-4.31,13.9-8.722a122.231,122.231,0,0,0,8.683-9.924",
    transform: "translate(181.68 78.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M332.3-519.772s2.759-5.025,7.355-3.943c2.654.624,3.126,3.781,0,3.933s-7.355.011-7.355.011",
    transform: "translate(90.587 51.297)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/Hands.4a3501cfd08957aeb12fe1b4b46dc17a.svg";
export { ForwardRef as ReactComponent };